import { z } from "zod";

export const ZVinduerGlassfasaderYtterdorerSchema = z.object({
  // 12
  isActive: z.boolean().default(false),
  tekst: z.string(),
  generelleForinger: z.object({
    // 12.1
    isActive: z.boolean().default(false),
    tekst: z.string(),
    vinduer: z.object({
      // 12.1.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    glassfasader: z.object({
      // 12.1.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    ytterdorer: z.object({
      // 12.1.3
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
  terskellosninger: z.object({
    // 12.2
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
});

export type IVinduerGlassfasaderYtterdorerSchema = z.infer<typeof ZVinduerGlassfasaderYtterdorerSchema>;
